import ENDPOINTS, { APP_NAME } from '@zet/end-points'
import { zetApi } from '@zet/network'
import { QuickFilter } from '@zet/utils/Constants'
import _ from 'lodash'

import { ILeadsFilterDto } from '../types'

const getLeadsFilterDto = (filterDto: ILeadsFilterDto) => {
  Object.keys(filterDto).forEach((key: string) => {
    if (typeof filterDto?.[key] !== 'number' && _.isEmpty(filterDto?.[key])) {
      delete filterDto[key]
    }
  })
  return JSON.stringify(filterDto)
}

export async function fetchAdvisorLeads(
  offset = 0,
  searchText?: string | undefined,
  leadsType?: string | undefined,
  limit?: number,
  category?: string
) {
  const response = await zetApi.request({
    url: ENDPOINTS[APP_NAME].fetchLeads.endpoint,
    method: ENDPOINTS[APP_NAME].fetchLeads.method,
    params: {
      filters: getLeadsFilterDto({
        offset: offset,
        limit: limit ?? 10,
        searchString: searchText as string,
        creditReportFilters: [],
        partner: QuickFilter.brands.value,
        stage: QuickFilter.stage.value,
        category: category ? [category] : QuickFilter.category.value,
        leadStatus: QuickFilter.profileStatus.value,
        ...(leadsType ? { type: leadsType } : {}),
      }),
    },
  })
  return { nextOffset: offset + 10, ...response.data?.data }
}
